<ng-container *ngIf="sup; then withSup else default"></ng-container>

<ng-template #withSup>
    <var>{{ formatted.integers }}.<sup>{{ formatted.decimals }}</sup></var>
</ng-template>

<ng-template #default>
    <var>{{ formatted.full }}</var>
</ng-template>
